
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import {
  getToken,
  setToken
} from '@/utils/auth'


Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: () => import('@/views/verify/index')
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () => import('@/views/home/home')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login')
  },
  {
    path: '/face',
    name: 'face',
    component: () => import('@/views/facelogin/index')
  },
  {
    path: '/update',
    name: 'update',
    component: () => import('@/views/changeface/changeface')
  }
]

const router = new VueRouter({
  routes
})



router.beforeEach(async (to, from, next) => {
  // determine whether the user has logged in
  console.log('to', to)
  console.log(to.query, 'to.queryto.query')
  if (to.query.hasOwnProperty('token')) {
    console.log(to.query.tenantId, 'to.queryto.tenantId')
    

    let token = to.query.token
    let uid = Number(to.query.uid)
    let status = to.query.status
    let device = to.query.device
    
    // 添加是否需要返回到来时的网址
    let downLoadUrl = '';

    // 先清空之前的返回地址
    try {
      window.localStorage.removeItem('returnUrl')
    } catch (error) {
      
    }

    if(to.query.hasOwnProperty('downLoadUrl')) {
      downLoadUrl = decodeURIComponent(to.query.downLoadUrl)
      window.localStorage.setItem('returnUrl', downLoadUrl)
    }

    window.localStorage.removeItem('faceInfo')
    window.localStorage.setItem('uid', uid);
    window.localStorage.setItem('faceToken', token);
  
    store.commit('SET_TOKEN', token)
    store.commit('SET_USERID', uid)
    store.commit('SET_ImportStatus', status)
    store.commit('SET_USERID', uid)
    store.commit('SET_DEVICE',device)
    if (to.path === '/login') { 
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    permission(to, next);
  }
})
// 区分app内嵌H5打开，还是直接打开网址
function permission(to, next) {
  
  if (window.localStorage.getItem('faceToken')) {
    console.log(to,'to')
    if (to.path === '/login') {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    if (to.path == '/login') {
      //重新触发的时候会进入到这里,因为to.path已经变为/login了，然后直接跳转到登录页
      next()
    } else {
      //第一次会走到这个位置，然后重新触发路由钩子函数beforeEach,
      //当重新触发钩子函数的时候这时的to.path已经变为/login
      next(`/login?redirect=${to.path}`)
    }
  }
}
export default router